import { FC } from "react";

import { DetailRow } from "../DetailRow/DetailRow";

import { useTranslate } from "@/common/hooks/useTranslate";

interface SalesDetailsProps {
  formName: string;
}

export const SalesDetails: FC<SalesDetailsProps> = ({ formName }) => {
  const { t } = useTranslate();
  return <DetailRow label={t("dashboard", "organizationAssistant.approval.campaignLabel")} value={formName} />;
};
